import React from 'react';
import { Col, Badge } from 'react-bootstrap';
// css
import './styles/commonStyles.css';

const PageHeader = ({ title, subTitle, badge }) => (  
  	<Col xs={12} lg={8} lgOffset={2} className="pageHeader">
      {(badge)
        ? <h1 className="pageTitle">{title} <Badge className="backgroundRed">{badge}</Badge></h1>
        : <h1 className="pageTitle">{title}</h1>}
	    <h2 className="pageSubTitle">{subTitle}</h2>
	  </Col>  
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/cmp/PageHeader.js